<div class="field">
    <div class="single-checkbox" (click)="modelChange.emit(!model)">
        <span class="fake-checkbox cursor-pointer" [class.active]="model" [class.error-field]="error"></span>
        <ng-content></ng-content>
    </div>
    @if (error) {
        <span class="error-field-display">{{error | display}}</span>
    }
</div>